import { Popover as TypeformPopover } from "@typeform/embed-react";

import { withStyle } from "./WithStyle";

export const StyledPopover = withStyle(TypeformPopover, "tf-v1-popover-button");

export default StyledPopover;
